import { Region } from '../region';
import { IPaymentProvider } from '../../providers/payment/payment.interface'
import { PaymentProviderCyberSource } from '../../providers/payment/payment.cybersource';
import { DirectBankBrand } from '../../model/types/payment-method-type';


/**
 * @description Geographical region the application is currently configured for, e.g. US, Spain, Australia.
 * @region Enumeration for this region.
 * @defaultCountryFrom Default value to use for send-from country, i.e. in price calculator
 * @defaultCurrencyFrom Default value to use for send-from currency, i.e. in price calculator
 * @defaultLanguage Default language culture to use, i.e. content translations
 */
export const regionValues = {
  region: Region.CL,
  regionId: 3105,
  defaultCountryFrom: 'CL',
  defaultCountryFromOnfido: 'CHL',
  defaultCountryCodeFrom: 56,
  defaultCurrencyFrom: 'CLP',
  defaultLanguageCulture: 'es-CL',
  defaultLocation: {
    latitude: -33.4489,
    longitude:  -70.6693
  },
  dateFormat: 'DD/MM/YYYY',    
  /**
   * @summary
   * Postal code Canada reference (changed to allow lowercase as well)
   * https://en.wikipedia.org/wiki/Postal_codes_in_Canada
   * https://howtodoinjava.com/regex/canada-postal-code-validation/
   */  
  postalCodeRegex:`^\\d{7}$`,
  links: {
    linkFaq: 'https://www.riamoneytransfer.com/us/en/mobile-content/faqs'
  },
  languageCultures: ['es-CL', 'en-CL', 'fr-CL'],
  regionalIp: '66.82.123.234',
  paymentProvider: <IPaymentProvider>new PaymentProviderCyberSource(),
  isPlaidEnabled: false,
  isBankAccountEnabled: false,
  useSecurityQuestions: false,
  oldRemittanceLogin: false,
  onfidoMaxAttempts: 1,
  directBankBrand: DirectBankBrand.Fintoc,
  distanceMetric: 'km',
  acceptInternationalCards:true,
  stagedRiaBrand: '',
  payNearMeBrand: '',
  isEu: false,
  isEMEA: false,
  notShowMarketingPushAlert: false,
  useVeriff: false,
  googlepayAdyenPaymentNetworks: [],
  applepayAdyenPaymentNetworks: [],
  adyenMerchantCapability: [],
  walletSettings:{
    isMerchantSupportEnable:false,
  },
  defaultTranslationParams: null,
  originalCountryAllowedOnly: false,
  canShowLogosOnQRScanner: false,
  airtimeServices:{
    isAirTimeSevice:false,
    isLocalOnly:false,
  },
  passCodeLength: 6,
  walletServices:[],
  isCountrySupportDecimal: true,
  showNewHomePage: true,
  autoEnableMarketingPreference: false,
  loginRootHomePage: "activity",
  adyenRegion: 'live-us'// https://docs.adyen.com/development-resources/live-endpoints/#client-side-environment-region
};



// WEBPACK FOOTER //
// ./src/environment/region/CL.ts